import { render, staticRenderFns } from "./IntroductoryInformationPage.vue?vue&type=template&id=629ab872&"
import script from "./IntroductoryInformationPage.vue?vue&type=script&lang=ts&"
export * from "./IntroductoryInformationPage.vue?vue&type=script&lang=ts&"
import style0 from "./IntroductoryInformationPage.vue?vue&type=style&index=0&id=629ab872&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports